import transactionsRoutes from "../components/transactions/router";
import { Component } from "vue";

export default [
  {
    path: "transactions",
    component: (): Promise<Component> =>
      import("../components/transactions/Transactions.vue"),
    children: transactionsRoutes,
  },
  {
    path: "profile",
    component: (): Promise<Component> => import("../components/Profile.vue"),
    name: "profile",
  },
  {
    path: "notifications",
    component: (): Promise<Component> =>
      import("../components/Notifications.vue"),
    name: "notifications",
  },
  {
    path: "logout",
    component: (): Promise<Component> => import("../components/Logout.vue"),
    name: "logout",
  },
  {
    path: "rules-confirmation",
    component: (): Promise<Component> =>
      import("../components/RulesConfirmation.vue"),
    name: "rules-confirmation",
  },
];
